export default __webpack_public_path__ + "static/media/IMG_2006.4e4471ea.JPG";